import { render } from "./EventList.vue?vue&type=template&id=065a871f"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=065a871f&scope=true&lang=css"
script.render = render

export default script